/**
 * Plan limits - Single source of truth for all usage limits
 * Used by both server (enforcement) and client (display)
 */

export const PLAN_LIMITS = {
  Trial: {
    enrichmentsPerMonth: 100,
    emailSendsPerMonth: 50,
    leadsPerMonth: 100,
    campaignsPerMonth: 5,
    contactsPerMonth: 100,
    workspaces: 3,
  },
  Starter: {
    enrichmentsPerMonth: 1000,
    emailSendsPerMonth: 5000,
    leadsPerMonth: 5000,
    campaignsPerMonth: 50,
    contactsPerMonth: 5000,
    workspaces: 3,
  },
  Pro: {
    enrichmentsPerMonth: 5000,
    emailSendsPerMonth: 25000,
    leadsPerMonth: 25000,
    campaignsPerMonth: 200,
    contactsPerMonth: 50000,
    workspaces: 15,
  },
  Free: {
    enrichmentsPerMonth: 1000,
    emailSendsPerMonth: 5000,
    leadsPerMonth: 5000,
    campaignsPerMonth: 50,
    contactsPerMonth: 5000,
    workspaces: 3,
  },
  None: {
    enrichmentsPerMonth: 0,
    emailSendsPerMonth: 0,
    leadsPerMonth: 0,
    campaignsPerMonth: 0,
    contactsPerMonth: 0,
    workspaces: 1,
  },
} as const;

export type PlanTier = keyof typeof PLAN_LIMITS;
export type PlanLimits = typeof PLAN_LIMITS[PlanTier];

/**
 * Format a number with commas for display (e.g., 5000 → "5,000")
 */
export function formatNumber(num: number): string {
  return num.toLocaleString('en-GB');
}

/**
 * Get formatted limit string for display (e.g., "5,000 email enrichments/month")
 */
export function formatLimitFeature(
  limit: number,
  singular: string,
  plural: string = singular + 's'
): string {
  if (limit === 0) return `No ${plural}`;
  const label = limit === 1 ? singular : plural;
  return `${formatNumber(limit)} ${label}`;
}
